import { ITypedReduxAction } from '../../../types/redux/actionType';
import { IPostPreviewAttributes } from '../../../types/postPreview';

export enum ESetPostPreviewAttributeActionType {
  Set = 'post/setPostPreviewAttribute/set',
}

export interface ISetPostPreviewAttribute<P extends keyof IPostPreviewAttributes = keyof IPostPreviewAttributes> {
  key: P;
  value?: IPostPreviewAttributes[P];
}

export type TSetPostPreviewAttribute = ITypedReduxAction<
  ESetPostPreviewAttributeActionType.Set,
  ISetPostPreviewAttribute
>;
